import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import { useNavigate, useParams } from "react-router-dom";
import { authUserData } from "../../utils/Helper";
import {
  Checkbox,
  Collapse,
  Form,
  Input,
  Spin,
  Table,
  Breadcrumb,
  Row,
  Col,
  Space,
  Tooltip,
  Layout,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { useTranslation } from "react-i18next";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import AssignRFQVendor from "../PR/AssignRFQVendor";
import moment from "moment";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";

const DiameterWiseViewVendorBidRFQ = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [apiLoading, setapiLoading] = useState(false);
  const [newState2, setNewState2] = useState([]);
  const [data, setData] = useState([]);
  const [CategoryId, setCtaegoryTree] = useState();
  const vendorBidId = id ? atob(id) : null;
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState([]);
  const [rfqnumber, setRFQNumber] = useState([]);
  const [AsFinalBidPrice, setIsFinalBidPrice] = useState("");
  const [rfqcurrency, setRFQCurrency] = useState([]);
  const [rfqfreight, setRFQFreight] = useState([]);
  const [rfqunloading, setRFQUnloading] = useState([]);
  const [rfqpricebasis, setRFQPriceBasis] = useState([]);
  const [rfqtransportInsurance, setRFQTransportInsurance] = useState([]);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [enableInputs, setEnableInputs] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [rfqopenorder, setRFQOpenOrder] = useState(false);
  const [rfqpricecap, setRFQPriceCap] = useState([]);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [buyingPattern, setBuyingPattern] = useState("");
  const [showUnitRateOfCement, setShowUnitRateOfCement] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [hideR0, setHideR0] = useState(false);
  const [hideR1, setHideR1] = useState(false);
  const [summaryTableData, setSummaryTableData] = useState([]);
  const [resetMode, setResetMode] = useState(false);
  const [revisedDate, setRevisedDate] = useState(false);
  const [finalDate, setFinalDate] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [showR0, setShowR0] = useState(false);
  const [rfqDetails, setRfqDetails] = useState([]);
  const [assignBuyer, setAssignBuyer] = useState([]);
  const [summaryTableData2, setSummaryTableData2] = useState([]);

  const [tableSummary, setTableSummary] = useState(tableData);

  const [summaryTableDataRevised, setSummaryTableDataRevised] = useState([]);
  const [summaryTableDataFinal, setSummaryTableDataFinal] = useState([]);

  const [winningArray, setWinningArray] = useState([]);
  const [lastFiveBid, setLastBid] = useState([]);
  const [showBidIcon, setShowBidIcon] = useState(false);

  const [bidRfqByVendor, setBidRfqByVendor] = useState(false);
  const [rfqAssignedOrNot, setRfqAssignedOrNot] = useState(null);
  const [isFinalBidPrice1, setIsFinalBidPrice1] = useState(false);

  const [initialBidDates, setInitialBidDates] = useState(null);
  const [revisedBidDates, setRevisedBidDates] = useState(null);
  const [finalBidDates, setFinalBidDates] = useState(null);

  const handleHideR0Change = (e) => {
    setHideR0(e.target.checked);
  };
  const handleHideR1Change = (e) => {
    setHideR1(e.target.checked);
  };
  const { Panel } = Collapse;
  const { Content } = Layout;
  const currentDate = (() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  })();

//   useEffect(() => {
//     const getVendorFive = async () => {
//       try {
//         const response = await getRequest(
//           `bid-rfq/${rfqDetails.vendor_id}/last-five-bid-results/?company_id=${rfqDetails.company_id}`
//         );

//         if (response?.data?.success === true) {
//           let last = response?.data?.data;
//           let lastReverse = last?.reverse();
//           setLastBid(lastReverse);
//         }
//       } catch (error) {
//         console.error("Error fetching vendor winning ratio:", error);
//       }
//     };

//     if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
//       getVendorFive();
//     }
//   }, [winningArray]);

  const [state, setState] = useState([]);
  const [rfqData, setRfqData] = useState({
    open_order: false,
    rfqamountcap: "",
    rfqtimelinecap: "",
    rfqopendeliverydate: "",
    rfqdeliverystartdate: "",
    rfqdeliveryenddate: "",
    rfqduedate: "",
    rfqpricecap: "",
  });

  const [showUnitRateOfFreight, setShowUnitRateOfFreight] = useState(false);

  const calculateUnitRateWithGst = (
    initialBidPriceUnitRate,
    quantity,
    gstRate
  ) => {
    return (
      initialBidPriceUnitRate * quantity * (gstRate / 100) +
      initialBidPriceUnitRate
    );
  };

//   useEffect(() => {
//     const getAssignBuyer = async () => {
//       try {
//         const response = await getRequest(`float-rfq/sales-manager-by-vendor/`);
//         setAssignBuyer(response.data.results.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     getAssignBuyer();
//   }, []);

//   useEffect(() => {
//     const getVendorWinningRatio = async () => {
//       try {
//         const response = await getRequest(
//           `bid-rfq/${rfqDetails.vendor_id}/bid-rfq-winning-ratio-of-one-year/?company_id=${rfqDetails.company_id}`
//         );

//         if (response?.data?.success === true) {
//           const arrayOfObjects = Object.entries(response.data.data).map(
//             ([key, value]) => ({ key, value })
//           );
//           setWinningArray(arrayOfObjects);
//         }
//       } catch (error) {
//         console.error("Error fetching vendor winning ratio:", error);
//       }
//     };

//     if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
//       getVendorWinningRatio();
//     }
//   }, [rfqDetails]);

  const handleInputChange = (e, siteName, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;
    const numericValue = parseFloat(value) || 0;

    setTableData((prevData) =>
      prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        if (
          record.siteId === siteName &&
          record.material_type === materialType
        ) {
          if (
            [
              "final_bid_price_unit_rate",
              "revised_bid_price_unit_rate",
              "initial_bid_price_unit_rate",
            ].includes(fieldName)
          ) {
            return {
              ...record,
              [fieldName]: numericValue,
              unit_rate_with_gst: calculateUnitRateWithGst(
                numericValue,
                record.material_total_quantity,
                record.gst_rate
              ),
            };
          } else {
            return {
              ...record,
              [fieldName]: numericValue,
            };
          }
        }

        return record;
      })
    );
  };

  const handleInputChangeDate = (e, siteId, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;

    setTableData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) => {
          if (site.site_id === siteId) {
            return {
              ...site,
              bid_rfq_material_details: site.bid_rfq_material_details.map(
                (material) => {
                  if (material.material_type === materialType) {
                    if (
                      [
                        "final_bid_price_unit_rate",
                        "revised_bid_price_unit_rate",
                        "initial_bid_price_date",
                      ].includes(fieldName)
                    ) {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                        unit_rate_with_gst: calculateUnitRateWithGst(
                          currentDate,
                          material.material_total_quantity,
                          material.gst_rate
                        ),
                      };
                      return updatedMaterial;
                    } else {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                      };
                      return updatedMaterial;
                    }
                  }
                  return material;
                }
              ),
            };
          }
          return site;
        }),
      }))
    );
  };

  const resetGSTValues = useCallback(() => {
    setTableData((prevData) =>
      prevData.map((item) => {
        if (item.material_type_name) {
          return {
            ...item,
          };
        }

        return item;
      })
    );
    setResetMode(true);
    setSummaryTableData((prevSummaryData) =>
      prevSummaryData?.map((city) => ({
        ...city,
        sites: city?.sites?.map((site) => ({
          ...site,
          totalAmountWithGst: 0,
          totalAmountWithoutGst: 0,
        })),
      }))
    );
  }, [setTableData, setResetMode]);

  const handleInputChangeUnitRateWIthGST = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_city_detail: city.bid_rfq_city_detail.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                material_details: site.material_details.map((material) =>
                  material.material_type === materialType
                    ? { ...material, unit_rate_with_gst: value }
                    : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeLQPForThisClient = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeAnyLqp = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_any_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };
  const handleDateChange = (cityIndex, siteIndex, field, value) => {
    const newData = [...tableData];
    newData[cityIndex].bid_rfq_site_details[siteIndex][field] = value;
    setTableData(newData);
  };
  function flattenGetResponseForTableData(getResponse) {
    const flatRows = [];
    if (!getResponse?.bid_rfq_city_wise_detail) return flatRows;
    let sr = 1;
    getResponse.bid_rfq_city_wise_detail.forEach((city) => {
      const city_name = city.city_name;
      // Start sr for each city
      city.bid_rfq_site_details.forEach((site) => {
        const site_id = site.site_id;
        const site_name = site.site_name;
        const seenSubCategories = new Set();
        const sortedMaterials = [...site.bid_rfq_material_details].sort(
          (a, b) =>
            a.material_type_sub_category.localeCompare(
              b.material_type_sub_category
            )
        );

        sortedMaterials.forEach((material, matInd) => {
          const {
            rfq_material_detail,
            material_type_name,
            material_type,
            material_total_quantity,
            material_total_quantity_by_kg,
            gst_rate,
            gst_rate_freight,
            id,
            material_wise_uom,
            unit_of_measurement,
            initial_bid_price_unit_rate,
            initial_bid_price_unit_rate_of_freight,
            revised_bid_price_unit_rate,
            revised_bid_price_unit_rate_of_freight,
            final_bid_price_unit_rate,
            final_bid_price_unit_rate_of_freight,
            initial_bid_amount_with_gst,
            initial_bid_amount_without_gst,
            revised_bid_amount_with_gst,
            revised_bid_amount_without_gst,
            final_bid_amount_with_gst,
            final_bid_amount_without_gst,
            unit_rate_with_gst,
            is_inital_final_bid,
            is_revised_final_bid,
            is_final_final_bid,
            is_initial_bid,
            is_revised_bid,
            is_final_bid,
            diameter_details,
            material_type_sub_category,
          } = material;

          const showSubCategory = !seenSubCategories.has(
            material_type_sub_category
          );
          seenSubCategories.add(material_type_sub_category);

          if (Array.isArray(diameter_details)) {
            diameter_details.forEach((dia) => {
              flatRows.push({
                city_name,
                site_id,
                site_name,
                rfq_material_detail,
                material_type_name,
                material_type,
                material_total_quantity,
                material_total_quantity_by_kg,
                gst_rate,
                gst_rate_freight,
                id,
                material_wise_uom,
                unit_of_measurement,
                initial_bid_price_unit_rate,
                initial_bid_price_unit_rate_of_freight,
                revised_bid_price_unit_rate,
                revised_bid_price_unit_rate_of_freight,
                final_bid_price_unit_rate,
                final_bid_price_unit_rate_of_freight,
                initial_bid_amount_with_gst,
                initial_bid_amount_without_gst,
                revised_bid_amount_with_gst,
                revised_bid_amount_without_gst,
                final_bid_amount_with_gst,
                final_bid_amount_without_gst,
                unit_rate_with_gst,
                is_inital_final_bid,
                is_revised_final_bid,
                is_final_final_bid,
                is_initial_bid,
                is_revised_bid,
                is_final_bid,
                // material_type_sub_category: matInd === 0 && material_type_sub_category,
                material_type_sub_category: showSubCategory
                  ? material_type_sub_category
                  : "",
                diameter_id: dia.diameter_id,
                diameter: dia.diameter_value,
                diameter_uom: dia.diameter_uom,
                quantity: dia.quantity,
                uom: dia.diameter_uom || material.material_wise_uom,
                ...dia,
                sr: sr,
              });
            });
          }
        });
      });
      sr++;
    });

    return flatRows;
  }
  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response1 = await getRequest(
          `bid-rfq/${id}/get-bid-rfq-city-wise/?vendor_id=${VendorId}`
        );
        const response = response1.data.data;

        // Use the new flattening utility to set tableData
        const flatTableData = flattenGetResponseForTableData(response);
        setTableData(flatTableData);
        setTableSummary(flatTableData); // If you use this elsewhere

        let cityTotals = {};
        let serialNumber = 0;
        let lastCityName = null;
        let lastSiteName = null;

        const fattenData = response.bid_rfq_city_wise_detail.flatMap(
          (cityDetail, cityIndex) => {
            const siteMap = {};
            if (!cityTotals[cityDetail.city_id]) {
              cityTotals[cityDetail.city_id] = {
                total_initial_bid_price_unit_rate: 0,
                total_revised_bid_price_unit_rate: 0,
                total_initial_bid_price_unit_rate_of_freight: 0,
                total_revised_bid_price_unit_rate_of_freight: 0,
                total_material_total_quantity: 0,
                total_material_total_quantity_kg: 0,
                total_gst_rate: 0,
                total_unit_rate_with_gst: 0,
              };
            }

            const intermediateTotals = {};

            cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
              const siteId = siteDetail.site_id;

              let siteSubtotal = 0;

              if (!siteMap[siteId]) {
                siteMap[siteId] = {
                  ...siteDetail,
                  bid_rfq_material_details: [],
                  showSiteName: true,
                  subtotal: {
                    initial_bid_price_unit_rate: 0,
                    initial_bid_price_unit_rate_of_freight: 0,
                    revised_bid_price_unit_rate: 0,
                    revised_bid_price_unit_rate_of_freight: 0,
                    material_total_quantity: 0,
                    material_total_quantity_by_kg: 0,
                    gst_rate: 0,
                    unit_rate_with_gst: 0,

                    unit_rate_with_gst_revised: 0,
                    unit_rate_with_gst_final: 0,

                    total_initial_bid_price_unit_rate: 0,
                    total_revised_bid_price_unit_rate: 0,
                  },
                };
              }

              let totalInitialBidPriceUnitRate = 0;

              siteDetail.bid_rfq_material_details.forEach((materialDetail) => {
                const materialType = materialDetail.material_type;
                const rfqVendorDetail = siteDetail.rfq_vendor_detail;

                const existingMaterial = siteMap[
                  siteId
                ].bid_rfq_material_details.find(
                  (material) => material.material_type === materialType
                );

                if (existingMaterial) {
                  existingMaterial.material_total_quantity +=
                    materialDetail.material_total_quantity || 0;
                  existingMaterial.material_total_quantity_by_kg +=
                    materialDetail.material_total_quantity_by_kg || 0;
                  existingMaterial.gst_rate += materialDetail.gst_rate || 0;
                  existingMaterial.initial_bid_price_unit_rate +=
                    materialDetail.initial_bid_price_unit_rate || 0;
                  existingMaterial.initial_bid_price_unit_rate_of_freight +=
                    materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                  existingMaterial.revised_bid_price_unit_rate +=
                    materialDetail.revised_bid_price_unit_rate || 0;
                  existingMaterial.revised_bid_price_unit_rate_of_freight +=
                    materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                  existingMaterial.unit_rate_with_gst +=
                    materialDetail.unit_rate_with_gst || 0;

                  existingMaterial.unit_rate_with_gst_revised +=
                    materialDetail.unit_rate_with_gst_revised || 0;

                  existingMaterial.rfq_vendor_detail = rfqVendorDetail;
                } else {
                  siteMap[siteId].bid_rfq_material_details.push({
                    ...materialDetail,
                    rfq_vendor_detail: rfqVendorDetail,
                  });
                }
                siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                siteMap[
                  siteId
                ].subtotal.initial_bid_price_unit_rate_of_freight +=
                  materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                siteMap[siteId].subtotal.revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;
                siteMap[
                  siteId
                ].subtotal.revised_bid_price_unit_rate_of_freight +=
                  materialDetail.revised_bid_price_unit_rate_of_freight || 0;

                siteMap[siteId].subtotal.material_total_quantity +=
                  materialDetail.material_total_quantity || 0;
                siteMap[siteId].subtotal.material_total_quantity_by_kg +=
                  materialDetail.material_total_quantity_by_kg || 0;
                siteMap[siteId].subtotal.gst_rate +=
                  materialDetail.gst_rate || 0;
                siteMap[siteId].subtotal.unit_rate_with_gst +=
                  materialDetail.unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.unit_rate_with_gst_revised +=
                  materialDetail.revised_unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.total_initial_bid_price_unit_rate +=
                  (materialDetail.material_total_quantity || 0) *
                  (materialDetail.initial_bid_price_unit_rate +
                    materialDetail.initial_bid_price_unit_rate_of_freight || 0);

                siteMap[siteId].subtotal.total_revised_bid_price_unit_rate +=
                  (materialDetail.material_total_quantity || 0) *
                  (materialDetail.revised_bid_price_unit_rate +
                    materialDetail.revised_bid_price_unit_rate_of_freight || 0);

                cityTotals[
                  cityDetail.city_id
                ].total_initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                cityTotals[
                  cityDetail.city_id
                ].total_revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_initial_bid_price_unit_rate_of_freight +=
                  materialDetail.initial_bid_price_unit_rate_of_freight || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_revised_bid_price_unit_rate_of_freight +=
                  materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                cityTotals[cityDetail.city_id].total_material_total_quantity +=
                  materialDetail.material_total_quantity || 0;
                cityTotals[
                  cityDetail.city_id
                ].total_material_total_quantity_kg +=
                  materialDetail.material_total_quantity_by_kg || 0;
                cityTotals[cityDetail.city_id].total_gst_rate +=
                  materialDetail.gst_rate || 0;
                cityTotals[cityDetail.city_id].total_unit_rate_with_gst +=
                  materialDetail.unit_rate_with_gst || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_unit_rate_with_gst_revised +=
                  materialDetail.unit_rate_with_gst_revised || 0;

                siteDetail.subtotal = siteSubtotal;

                const unitRate =
                  materialDetail.initial_bid_price_unit_rate || 0;
                const totalQtyKg =
                  materialDetail.material_total_quantity_by_kg || 0;

                // Correct material total calculation
                const materialTotal = unitRate * totalQtyKg;

                // Accumulate to the site's subtotal
                siteSubtotal += materialTotal;

                // Update intermediateTotals for the site
                intermediateTotals[siteId] =
                  (intermediateTotals[siteId] || 0) + materialTotal;

                totalInitialBidPriceUnitRate += materialTotal;
              });
            });

            let totalInitialBidPriceUnitRate = 0;

            const siteRows = Object.values(siteMap).flatMap(
              (site, siteIndex) => {
                const materialRows = site.bid_rfq_material_details.map(
                  (material) => {
                    const isCityChanged = lastCityName !== cityDetail.city_name;
                    const isSiteChanged = lastSiteName !== site.site_name;

                    const siteInitialBidPrice =
                      site.subtotal.material_total_quantity_by_kg *
                      site.subtotal.initial_bid_price_unit_rate;

                    totalInitialBidPriceUnitRate += siteInitialBidPrice;

                    if (isCityChanged) {
                      serialNumber++;
                      lastCityName = cityDetail.city_name;
                    }

                    if (isSiteChanged) {
                      lastSiteName = site.site_name;
                    }

                    const qtyKg = material.material_total_quantity_by_kg || 0;
                    const unitRate = material.initial_bid_price_unit_rate || 0;

                    const materialTotal =
                      (material.material_total_quantity_by_kg || 0) *
                      (material.initial_bid_price_unit_rate || 0);

                    intermediateTotals[site.site_id] =
                      (intermediateTotals[site.site_id] || 0) + materialTotal;

                    return {
                      sr_no: isCityChanged ? serialNumber : null,
                      city_id: cityDetail.city_name,
                      city_name: isCityChanged
                        ? cityDetail.city_name || null
                        : null,
                      site_name: isSiteChanged ? site.site_name || null : null,
                      siteId: site.site_id,
                      material_type_name: material.material_type_name || "",
                      material_wise_uom: material.material_wise_uom || "",
                      material_wise_uom_id: material.unit_of_measurement,
                      material_type: material.material_type || null,
                      material_total_quantity:
                        material.material_total_quantity || 0,
                      material_total_quantity_by_kg:
                        material.material_total_quantity_by_kg || 0,
                      gst_rate: material.gst_rate || 0,
                      gst_rate_freight: material.gst_rate_freight || 0,
                      initial_bid_price_unit_rate:
                        material.initial_bid_price_unit_rate || 0,

                      initial_bid_price_amount:
                        material.initial_bid_price_unit_rate *
                          material.material_total_quantity +
                          material.initial_bid_price_unit_rate_of_freight *
                            material.material_total_quantity || 0,

                      initial_bid_price_unit_rate_of_freight:
                        material.initial_bid_price_unit_rate_of_freight || 0,
                      revised_bid_price_unit_rate:
                        material.revised_bid_price_unit_rate || 0,

                      revised_bid_price_amount:
                        material.revised_bid_price_unit_rate *
                          material.material_total_quantity +
                          material.revised_bid_price_unit_rate_of_freight *
                            material.material_total_quantity || 0,

                      revised_bid_price_unit_rate_of_freight:
                        material.revised_bid_price_unit_rate_of_freight || 0,
                      final_bid_price_unit_rate:
                        material.final_bid_price_unit_rate,

                      final_bid_price_amount:
                        material.final_bid_price_unit_rate *
                          material.material_total_quantity +
                          material.final_bid_price_unit_rate_of_freight *
                            material.material_total_quantity || 0,

                      final_bid_price_unit_rate_of_freight:
                        material.final_bid_price_unit_rate_of_freight,
                      unit_rate_with_gst: material.unit_rate_with_gst || 0,
                      unit_rate_with_gst_revised:
                        material.revised_unit_rate_with_gst || 0,
                      rfq_vendor_detail: material.rfq_vendor_detail,
                      initial_bid_price_date: material.initial_bid_price_date,
                      revised_bid_price_date: material.revised_bid_price_date,
                      final_bid_price_date: material.final_bid_price_date,
                      rfq_material_detail: material.rfq_material_detail,
                      bid_rfq_id: material.bid_rfq_id || null,
                      is_initial_bid: material?.is_initial_bid,
                      is_revised_bid: material?.is_revised_bid,
                      is_final_bid: material?.is_final_bid,
                    };
                  }
                );

                let materialTotal = 0;

                const qty = site.subtotal.material_total_quantity || 0;
                const qtyKg = site.subtotal.material_total_quantity_by_kg || 0;

                materialTotal += qty * qtyKg;

                intermediateTotals[site.site_id] =
                  (intermediateTotals[site.site_id] || 0) + materialTotal;

                materialRows.push({
                  key: `${cityIndex}-${siteIndex}-SubTotal`,
                  siteName: "Sub-Total",
                  siteId: site.site_id,
                  qty: site.subtotal.material_total_quantity,
                  qty_kg: site.subtotal.material_total_quantity_by_kg,

                  total_initial_bid_price_unit_rate:
                    site.subtotal.total_initial_bid_price_unit_rate || 0,

                  total_initial_bid_price_unit_rate_of_freight:
                    site.subtotal.initial_bid_price_unit_rate_of_freight,

                  total_revised_bid_price_unit_rate:
                    site.subtotal.total_revised_bid_price_unit_rate,

                  total_revised_bid_price_unit_rate_of_freight:
                    site.subtotal.revised_bid_price_unit_rate_of_freight,

                  total_unit_rate_with_gst: site.subtotal.unit_rate_with_gst,

                  total_unit_rate_with_gst_revised:
                    site.subtotal.unit_rate_with_gst_revised,

                  total_unit_rate_with_gst_final:
                    site.subtotal.unit_rate_with_gst_final,
                });

                return materialRows;
              }
            );

            const totalInitialBidPrice2 = siteRows.reduce(
              (acc, row) => acc + (row.total_initial_bid_price_unit_rate || 0),
              0
            );

            const cityId = [
              ...new Set(siteRows.map((row) => row.city_id)),
            ].join("");

            const totalQty = siteRows.reduce(
              (acc, row) => acc + (row.material_total_quantity || 0),
              0
            );
            const totalQtyInKg = siteRows.reduce(
              (acc, row) => acc + (row.material_total_quantity_by_kg || 0),
              0
            );

            // Calculate the subtotal for 'initial_bid_price_unit_rate'
            const totalInitialBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_initial_bid_price_unit_rate || 0),
              0
            );

            const totalInitialBidFreightPrice = siteRows.reduce(
              (acc, row) =>
                acc + (row.total_initial_bid_price_unit_rate_of_freight || 0),
              0
            );

            const totalRevisedBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_revised_bid_price_unit_rate || 0),
              0
            );
            const totalRevisedBidFreightPrice = siteRows.reduce(
              (acc, row) =>
                acc + (row.total_revised_bid_price_unit_rate_of_freight || 0),
              0
            );

            const totalInitialUnitRateGST = siteRows.reduce(
              (acc, row) => acc + (row.total_unit_rate_with_gst || 0),
              0
            );

            const totalRevisedUnitRateGST = siteRows.reduce(
              (acc, row) => acc + (row.total_unit_rate_with_gst_revised || 0),
              0
            );

            const totalFinalUnitRateGST = siteRows.reduce(
              (acc, row) => acc + (row.total_unit_rate_with_gst_final || 0),
              0
            );

            siteRows.push({
              key: `city-${cityIndex}-Total`,
              siteName: "City-Total",
              city_id: cityId,
              qty: totalQty,
              qty_kg: totalQtyInKg,

              total_initial_bid_price_unit_rate: totalInitialBidPrice,

              total_initial_bid_price_unit_rate_of_freight:
                totalInitialBidFreightPrice,

              total_revised_bid_price_unit_rate: totalRevisedBidPrice,

              total_revised_bid_price_unit_rate_of_freight:
                totalRevisedBidFreightPrice,
              total_unit_rate_with_gst: totalInitialUnitRateGST,
              // total_unit_rate_with_gst: "",

              total_unit_rate_with_gst_revised: totalRevisedUnitRateGST,

              total_unit_rate_with_gst_final: totalFinalUnitRateGST,
            });
            return siteRows;
          }
        );

        // setTableData(fattenData); // <-- Remove or comment out this line to prevent overwriting the correct tableData

        const newFat = fattenData;

        setTableSummary(newFat);

        if (response?.bid_rfq_city_wise_detail) {
          let initialDates = null;
          let revisedDates = null;
          let finalDates = null;

          const firstCity = response.bid_rfq_city_wise_detail[0];
          if (firstCity) {
            const firstSite = firstCity.bid_rfq_site_details[0];

            if (firstSite) {
              const firstMaterial =
                firstSite.bid_rfq_material_details[0].diameter_details[0];
              if (firstMaterial) {
                initialDates = firstMaterial.initial_bid_price_date || null;
                revisedDates = firstMaterial.revised_bid_price_date || null;
                finalDates = firstMaterial.final_bid_price_date || null;
              }
            }
          }

          setInitialBidDates(initialDates);
          setRevisedBidDates(revisedDates);
          setFinalBidDates(finalDates);
        }

        setCompanyName(response.company);
        if (
          response.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
            .bid_rfq_material_details[0].diameter_details[0]
            .initial_bid_price_date !== null
        ) {
          setHideR1(false);
          setCurrentStep(1);
          resetGSTValues();
        }
        if (
          response.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
            .bid_rfq_material_details[0].diameter_details[0]
            .revised_bid_price_date !== null
        ) {
          setHideR1(false);
          setCurrentStep(2);
          resetGSTValues();
        }
        setRfqDetails(response);
        setRFQNumber(response.rfq_number);
        setRFQCurrency(response.currency_name);
        setRFQPriceBasis(response.price_basis);
        setRFQFreight(response.freight);
        setRFQUnloading(response.unloading);
        setRFQTransportInsurance(response.transport_insurance);
        setRFQOpenOrder(response.open_order);
        setRFQPriceCap(response.price_cap);
        setRfqData({
          open_order: response.open_order,
          rfqamountcap: response.amount_cap,
          rfqtimelinecap: response.timeline_cap,
          rfqopendeliverydate: response.delivery_date,
          rfqdeliverystartdate: response.delivery_start_date,
          rfqdeliveryenddate: response.delivery_end_date,
          rfqduedate: response.rfq_due_date,
          rfqpricecap: response.price_cap,
        });
        setState((prevState) => {
          return {
            ...prevState,
            bid_rfq_city_wise_detail: response.bid_rfq_city_wise_detail,
          };
        });
        const buying_pattern = response.buying_pattern;
        // setBuyingPatternPayload(buying_pattern);
        setBuyingPattern(buying_pattern);
        if (buying_pattern === "Unit Rate of Cement excluding Freight") {
          setShowUnitRateOfCement(true);
          setShowUnitRateOfFreight(true);
        } else if (buying_pattern === "Unit Rate of Cement including Freight") {
          setShowUnitRateOfCement(true);
          setShowUnitRateOfFreight(false);
        } else if (buying_pattern === "Total Unit Rate") {
          setShowUnitRateOfCement(false);
          setShowUnitRateOfFreight(true);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [vendorBidId]);
  const [siteWithoutGstRates, setSiteWithoutGstRates] = useState({});
  const hideR1Columns = hideR1 ? [] : {};

  const calculateSubtotals = (tableData) => {
    let siteSubtotals = {};
    let grandTotalCement = 0;
    let grandTotalFreight = 0;

    tableData.forEach((record) => {
      if (!record.isSubtotal) {
        const siteId = record.siteId;
        if (!siteSubtotals[siteId]) {
          siteSubtotals[siteId] = {
            totalCement: 0,
            totalFreight: 0,
          };
        }
        siteSubtotals[siteId].totalCement += Number(
          record.initial_bid_price_unit_rate || 0
        );
        siteSubtotals[siteId].totalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
        grandTotalCement += Number(record.initial_bid_price_unit_rate || 0);
        grandTotalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
      }
    });

    return { grandTotalCement, grandTotalFreight, siteSubtotals };
  };

  const isRfqDueDateValid = () => {
    const dueDate = moment(rfqDetails.rfq_due_date, "DD-MM-YYYY HH:mm");
    return dueDate.isValid() && dueDate.isAfter(moment());
  };

  const { grandTotalCement, grandTotalFreight, siteSubtotals } =
    calculateSubtotals(tableData);

  // Parse and check if due date-time is passed
  const dueDateStr = rfqDetails.rfq_due_date; // "23-05-25 09:00"
  let disableAssign = false;

  if (dueDateStr) {
    const [datePart, timePart] = dueDateStr.split(" ");
    const [yy, mm, dd] = datePart.split("-").map(Number);
    const [hh, min] = timePart.split(":").map(Number);

    const fullYear = 2000 + yy; // Convert 23 → 2023
    const dueDate = new Date(fullYear, mm - 1, dd, hh, min);

    disableAssign = dueDate < new Date();
  }

  const groupedColumns = [
    {
      title: "Sr.",
      dataIndex: "sr",
      width: 50,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "City",
      dataIndex: "city_name",
      width: 120,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Site",
      dataIndex: "site_name",
      width: 120,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].site_name !== tableData[index - 1].site_name ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Sub category",
      dataIndex: "material_type_sub_category",
      width: 140,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].material_type_name !==
            tableData[index - 1].material_type_name ||
          tableData[index].site_name !== tableData[index - 1].site_name ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Material Type",
      dataIndex: "material_type_name",
      width: 180,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].material_type_name !==
            tableData[index - 1].material_type_name ||
          tableData[index].site_name !== tableData[index - 1].site_name ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      width: 100,
      render: (text, row) =>
        text ? `${text} ${(row.diameter_uom || "").toUpperCase()}`.trim() : "",
    },
    {
      title: "Qty.",
      dataIndex: "quantity",
      width: 60,
    },
    {
      title: "UoM.",
      dataIndex: "material_wise_uom",
      key: "material_wise_uom",
      width: 100,
      render: (text) => text,
    },
    finalBidDates !== null && {
      title: `R (Without GST)${
        finalBidDates ? " (" + finalBidDates + ")" : ""
      }`,
      children: [
        {
          title: "Unit Rate",
          dataIndex: "final_bid_price_unit_rate",
          align: "right",
          width: "120px",
          render: (text, row) => {
            if (finalBidDates) {
              return <span>{text !== 0 ? `₹ ${text}` : "N/A" || ""}</span>;
            } else {
              return <span>0</span>;
            }
          },
        },
        {
          title: "Unit Rate Freight",
          dataIndex: "final_bid_price_unit_rate_of_freight",
          key: "final_bid_price_unit_rate_of_freight",
          align: "right",
          width: "100px",
          render: (text, row) => {
            const isDisabled =
              row?.siteName === "Sub-Total" || row?.siteName === "City-Total";

            if (finalBidDates) {
              return <span>{text !== 0 ? `₹ ${text}` : "N/A" || ""}</span>;
            } else {
              return <span>0</span>;
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "r_amount",
          width: "130px",
          align: "right",
          render: (text, row) => {
            const val =
              (parseFloat(row.final_bid_price_unit_rate || 0) +
                parseFloat(row.final_bid_price_unit_rate_of_freight || 0)) *
              parseFloat(row.quantity || 0);
            return `₹ ${val.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })}`;
          },
        },
        {
          title: "Unit Rate With GST",
          dataIndex: "r_unit_rate_with_gst",
          width: "130px",
          align: "right",
          render: (text, row) => {
            const val =
              parseFloat(row.final_bid_price_unit_rate || 0) *
                (1 + (row.gst_rate || 0) / 100) +
              parseFloat(row.final_bid_price_unit_rate_of_freight || 0) *
                (1 + (row.gst_rate_freight || 0) / 100);
            return `₹ ${val.toFixed(2)}`;
          },
        },
      ],
    },
    !hideR1 &&
      revisedBidDates !== null && {
        title: `R1 (Without GST)${
          revisedBidDates ? " (" + revisedBidDates + ")" : ""
        }`,
        children: [
          {
            title: "Unit Rate",
            dataIndex: "revised_bid_price_unit_rate",
            align: "right",
            width: "120px",
            render: (text, row) => {
              if (revisedBidDates) {
                return <span>{text !== 0 ? `₹ ${text}` : "N/A" || ""}</span>;
              } else {
                return <span>0</span>;
              }
            },
          },
          {
            title: "Unit Rate Freight",
            dataIndex: "revised_bid_price_unit_rate_of_freight",
            key: "revised_bid_price_unit_rate_of_freight",
            align: "right",
            width: "100px",
            render: (text, row) => {
              const isDisabled =
                row?.siteName === "Sub-Total" || row?.siteName === "City-Total";

              if (revisedBidDates) {
                return <span>{text !== 0 ? `₹ ${text}` : "N/A" || ""}</span>;
              } else {
                return <span>N/A</span>;
              }
            },
          },
          {
            title: "Amount",
            dataIndex: "r1_amount",
            width: "130px",
            align: "right",
            render: (text, row) => {
              const val =
                (parseFloat(row.revised_bid_price_unit_rate || 0) +
                  parseFloat(row.revised_bid_price_unit_rate_of_freight || 0)) *
                parseFloat(row.quantity || 0);
              return `₹ ${val.toLocaleString("en-IN", {
                maximumFractionDigits: 2,
              })}`;
            },
          },
          {
            title: "Unit Rate With GST",
            dataIndex: "r1_unit_rate_with_gst",
            width: "130px",
            align: "right",
            render: (text, row) => {
              const val =
                parseFloat(row.revised_bid_price_unit_rate || 0) *
                  (1 + (row.gst_rate || 0) / 100) +
                parseFloat(row.revised_bid_price_unit_rate_of_freight || 0) *
                  (1 + (row.gst_rate_freight || 0) / 100);
              return `₹ ${val.toFixed(2)}`;
            },
          },
        ],
      },

    !hideR0 && {
      title: `R0 (Without GST)${
        initialBidDates ? " (" + initialBidDates + ")" : ""
      }`,
      children: [
        {
          title: "Unit Rate",
          dataIndex: "initial_bid_price_unit_rate",
          align: "right",
          width: "95px",
          render: (text, row) => {
            if (initialBidDates) {
              return <span>{text !== 0 ? `₹ ${text}` : "N/A" || ""}</span>;
            } else {
              return <span>0</span>;
            }
          },
        },
        {
          title: "Unit Rate Freight",
          dataIndex: "initial_bid_price_unit_rate_of_freight",
          key: "initial_bid_price_unit_rate_of_freight",
          align: "right",
          width: "100px",
          render: (text, row) => {
            const isDisabled =
              row?.siteName === "Sub-Total" || row?.siteName === "City-Total";

            if (initialBidDates) {
              return <span>{text !== 0 ? `₹ ${text}` : "N/A" || ""}</span>;
            } else {
              return <span>0</span>;
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "r0_amount",
          width: "130px",
          align: "right",
          render: (text, row) => {
            const val =
              (parseFloat(row.initial_bid_price_unit_rate || 0) +
                parseFloat(row.initial_bid_price_unit_rate_of_freight || 0)) *
              parseFloat(row.quantity || 0);
            return `₹ ${val.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })}`;
          },
        },
        {
          title: "Unit Rate With GST",
          dataIndex: "r0_unit_rate_with_gst",
          width: "130px",
          align: "right",
          render: (text, row) => {
            const val =
              parseFloat(row.initial_bid_price_unit_rate || 0) *
                (1 + (row.gst_rate || 0) / 100) +
              parseFloat(row.initial_bid_price_unit_rate_of_freight || 0) *
                (1 + (row.gst_rate_freight || 0) / 100);
            return `₹ ${val.toFixed(2)}`;
          },
        },
      ],
    },
  ].filter(Boolean);

  const columns2 = [
    {
      title: "City Name",
      dataIndex: "city_name",
      key: "city_name",
      render: (text, record) => <span>{record.city_name}</span>,
    },
    {
      title: "Site Name",
      dataIndex: "site_name",
      key: "site_name",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <Input
              disabled
              key={site.site_id}
              value={site.site_name}
              className="InputItem"
            />
          ))}
        </div>
      ),
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_with_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_without_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
  ];

  const getColumns3 = () => {
    const columns3 = [
      {
        title: "City",
        dataIndex: "city",
        key: "city",
        width: 120,
        fixed: "left",
        render: (city, record, rowIndex) => {
          const data = summaryTableData;
          if (rowIndex === 0 || city !== data[rowIndex - 1].city) {
            return <div>{city}</div>;
          }
          return null;
        },
      },
      {
        title: "Site",
        dataIndex: "site",
        key: "site",
        width: 130,
        fixed: "left",
        render: (site, record) => {
          if (record.site === "Total") {
            return <div className="total3">Total</div>;
          }
          return <div>{site || "No site data"}</div>;
        },
      },
    ].filter(Boolean);

    if (finalBidDates) {
      const R_col = currentStep >= 2 && {
        title: "R",
        children: [
          {
            title: "Amount Without GST",
            dataIndex: "totalAmountWithoutGstR",
            key: "amountWithoutGstR",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithoutGstR || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithoutGstR || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount With GST",
            dataIndex: "totalAmountWithGstR",
            key: "amountWithGstR",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithGstR || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithGstR || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
        ].filter(Boolean),
      };
      const R1_col = !hideR1 &&
        currentStep >= 1 && {
          title: "R1",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "totalAmountWithoutGstR1",
              key: "amountWithoutGstR1",
              width: 150,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithoutGstR1 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithoutGstR1 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "totalAmountWithGstR1",
              key: "amountWithGstR1",
              width: 150,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR1 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithGstR1 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        };
      const R0_col = !hideR0 && {
        title: "R0",
        children: [
          {
            title: "Amount Without GST",
            dataIndex: "totalAmountWithoutGstR0",
            key: "amountWithoutGstR0",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithoutGstR0 || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithoutGstR0 || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount With GST",
            dataIndex: "totalAmountWithGstR0",
            key: "amountWithGstR0",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithGstR0 || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithGstR0 || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
        ].filter(Boolean),
      };
      if (R_col) columns3.push(R_col);
      if (R1_col) columns3.push(R1_col);
      if (R0_col) columns3.push(R0_col);
    } else {
      if (initialBidDates) {
        const R1_col = !hideR1 &&
          currentStep >= 1 && {
            title: "R1",
            children: [
              {
                title: "Amount Without GST",
                dataIndex: "totalAmountWithoutGstR1",
                key: "amountWithoutGstR1",
                width: 200,
                align: "right",
                render: (amount, record) => {
                  if (record.site === "Total") {
                    const total = record.totalAmountWithoutGstR1 || 0;
                    return (
                      <div className="total3">
                        {`₹ ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}`}
                      </div>
                    );
                  } else {
                    const percentage = record.percentageWithoutGstR1 || "0";
                    return (
                      <div>
                        {`₹ ${amount?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })} (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
              {
                title: "Amount With GST",
                dataIndex: "totalAmountWithGstR1",
                key: "amountWithGstR1",
                width: 200,
                align: "right",
                render: (amount, record) => {
                  if (record.site === "Total") {
                    const total = record.totalAmountWithGstR1 || 0;
                    return (
                      <div className="total3">
                        {`₹ ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}`}
                      </div>
                    );
                  } else {
                    const percentage = record.percentageWithGstR1 || "0";
                    return (
                      <div>
                        {`₹ ${amount?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })} (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
            ].filter(Boolean),
          };
        const R0_col = !hideR0 && {
          title: "R0",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "totalAmountWithoutGstR0",
              key: "amountWithoutGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithoutGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithoutGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "totalAmountWithGstR0",
              key: "amountWithGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        };
        if (R1_col) columns3.push(R1_col);
        if (R0_col) columns3.push(R0_col);
      } else {
        const R0_col = !hideR0 && {
          title: "R0",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "totalAmountWithoutGstR0",
              key: "amountWithoutGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithoutGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithoutGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "totalAmountWithGstR0",
              key: "amountWithGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        };
        if (R0_col) columns3.push(R0_col);
      }
    }

    return columns3.map((col) => ({
      ...col,
      filterDropdown: col.filterDropdown || null,
    }));
  };

  const columns3 = getColumns3();
  useEffect(() => {
    // Map: city_name -> site_name -> siteData
    const cityMap = new Map();
    let totalWithGstR0 = 0,
      totalWithoutGstR0 = 0;
    let totalWithGstR1 = 0,
      totalWithoutGstR1 = 0;
    let totalWithGstR = 0,
      totalWithoutGstR = 0;
    // Declare these variables for the total row
    let totalAmountWithGstR0 = 0;
    let totalAmountWithoutGstR0 = 0;
    let totalAmountWithGstR1 = 0;
    let totalAmountWithoutGstR1 = 0;
    let totalAmountWithGstR = 0;
    let totalAmountWithoutGstR = 0;

    tableData.forEach((item) => {
      if (!item.site_name) return;
      const cityKey = item.city_name;
      const siteKey = item.site_name;

      // Use correct field names for each bid stage
      const unitRateR0 = parseFloat(item.initial_bid_price_unit_rate) || 0;
      const unitRateR0Freight =
        parseFloat(item.initial_bid_price_unit_rate_of_freight) || 0;
      const quantity = parseFloat(item.quantity) || 0;
      const gstRate = parseFloat(item.gst_rate) || 0;
      const gstRateFreight = parseFloat(item.gst_rate_freight) || 0;

      const amountWithoutGstR0 =
        unitRateR0 * quantity + unitRateR0Freight * quantity;
      const amountWithGstR0 =
        unitRateR0 * quantity * (1 + gstRate / 100) +
        unitRateR0Freight * quantity * (1 + gstRateFreight / 100);

      const unitRateR1 = parseFloat(item.revised_bid_price_unit_rate) || 0;
      const unitRateR1Freight =
        parseFloat(item.revised_bid_price_unit_rate_of_freight) || 0;
      const amountWithoutGstR1 =
        unitRateR1 * quantity + unitRateR1Freight * quantity;
      const amountWithGstR1 =
        unitRateR1 * quantity * (1 + gstRate / 100) +
        unitRateR1Freight * quantity * (1 + gstRateFreight / 100);

      const unitRateR = parseFloat(item.final_bid_price_unit_rate) || 0;
      const unitRateRFreight =
        parseFloat(item.final_bid_price_unit_rate_of_freight) || 0;
      const amountWithoutGstR =
        unitRateR * quantity + unitRateRFreight * quantity;
      const amountWithGstR =
        unitRateR * quantity * (1 + gstRate / 100) +
        unitRateRFreight * quantity * (1 + gstRateFreight / 100);

      // Get or create city
      if (!cityMap.has(cityKey)) {
        cityMap.set(cityKey, { city: cityKey, sites: new Map() });
      }
      const city = cityMap.get(cityKey);

      // Get or create site
      if (!city.sites.has(siteKey)) {
        city.sites.set(siteKey, {
          site: siteKey,
          totalAmountWithGstR0: 0,
          totalAmountWithoutGstR0: 0,
          totalAmountWithGstR1: 0,
          totalAmountWithoutGstR1: 0,
          totalAmountWithGstR: 0,
          totalAmountWithoutGstR: 0,
        });
      }
      const site = city.sites.get(siteKey);

      // Accumulate
      site.totalAmountWithGstR0 += amountWithGstR0;
      site.totalAmountWithoutGstR0 += amountWithoutGstR0;
      site.totalAmountWithGstR1 += amountWithGstR1;
      site.totalAmountWithoutGstR1 += amountWithoutGstR1;
      site.totalAmountWithGstR += amountWithGstR;
      site.totalAmountWithoutGstR += amountWithoutGstR;

      // Grand totals
      totalWithGstR0 += amountWithGstR0;
      totalWithoutGstR0 += amountWithoutGstR0;
      totalWithGstR1 += amountWithGstR1;
      totalWithoutGstR1 += amountWithoutGstR1;
      totalWithGstR += amountWithGstR;
      totalWithoutGstR += amountWithoutGstR;
      // For the total row variables
      totalAmountWithGstR0 += amountWithGstR0;
      totalAmountWithoutGstR0 += amountWithoutGstR0;
      totalAmountWithGstR1 += amountWithGstR1;
      totalAmountWithoutGstR1 += amountWithoutGstR1;
      totalAmountWithGstR += amountWithGstR;
      totalAmountWithoutGstR += amountWithoutGstR;
    });

    // Calculate percentages and build final array
    const finalData = [];
    cityMap.forEach((city) => {
      const citySites = [];
      city.sites.forEach((site) => {
        site.percentageWithoutGstR0 = totalWithoutGstR0
          ? ((site.totalAmountWithoutGstR0 / totalWithoutGstR0) * 100).toFixed(
              2
            )
          : 0;
        site.percentageWithGstR0 = totalWithGstR0
          ? ((site.totalAmountWithGstR0 / totalWithGstR0) * 100).toFixed(2)
          : 0;
        site.percentageWithoutGstR1 = totalWithoutGstR1
          ? ((site.totalAmountWithoutGstR1 / totalWithoutGstR1) * 100).toFixed(
              2
            )
          : 0;
        site.percentageWithGstR1 = totalWithGstR1
          ? ((site.totalAmountWithGstR1 / totalWithGstR1) * 100).toFixed(2)
          : 0;
        site.percentageWithoutGstR = totalWithoutGstR
          ? ((site.totalAmountWithoutGstR / totalWithoutGstR) * 100).toFixed(2)
          : 0;
        site.percentageWithGstR = totalWithGstR
          ? ((site.totalAmountWithGstR / totalWithGstR) * 100).toFixed(2)
          : 0;
        citySites.push(site);
        finalData.push({ city: city.city, ...site });
      });
    });

    // Add total row
    finalData.push({
      site: "Total",
      totalAmountWithGstR0,
      totalAmountWithoutGstR0,
      totalAmountWithGstR1,
      totalAmountWithoutGstR1,
      totalAmountWithGstR,
      totalAmountWithoutGstR,
    });

    setSummaryTableData(finalData);
  }, [tableData]);

  useEffect(() => {
    const materialTotals = {};

    tableData.forEach((row) => {
      const key = row.material_type_name;
      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_sub_category: row.material_type_sub_category,
          material_type_name: key,
          total_quantity: 0,
          total_cost: 0,
          uom: row.material_wise_uom || "MT",
          sizeGroups: {}, // To aggregate by size inside each material
        };
      }

      // Convert quantity to MT
      let qtyMT = 0;
      if ((row.material_wise_uom || row.uom) === "KG") {
        qtyMT = (row.quantity || 0) / 1000;
      } else {
        qtyMT = row.quantity || 0;
      }

      const size = row.diameter || "Unknown Size";

      const pricePerMT =
        Number(row.initial_bid_price_unit_rate || 0) +
        Number(row.initial_bid_price_unit_rate_of_freight || 0);

      // Initialize size group if not exists
      if (!materialTotals[key].sizeGroups[size]) {
        materialTotals[key].sizeGroups[size] = {
          total_quantity: 0,
          total_cost: 0,
        };
      }

      materialTotals[key].sizeGroups[size].total_quantity += qtyMT;
      materialTotals[key].sizeGroups[size].total_cost += pricePerMT * qtyMT;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const sizeGroups = material.sizeGroups;
      let totalCost = 0;
      let totalQty = 0;

      Object.values(sizeGroups).forEach(({ total_quantity, total_cost }) => {
        totalQty += total_quantity;
        totalCost += total_cost;
      });

      const averagePriceKG = totalQty ? totalCost / (totalQty * 1000) : 0;
      const averagePriceMT = averagePriceKG * 1000;

      return {
        material_type_sub_category: material.material_type_sub_category,
        material_type_name: material.material_type_name,
        total_quantity: totalQty,
        total_cost: totalCost,
        averagePriceKG,
        averagePriceMT,
        sizes: Object.entries(sizeGroups).map(([size, data]) => {
          const avgPriceKG = data.total_quantity
            ? data.total_cost / (data.total_quantity * 1000)
            : 0;
          return {
            size,
            total_quantity: data.total_quantity,
            total_cost: data.total_cost,
            averagePriceKG: avgPriceKG,
            averagePriceMT: avgPriceKG * 1000,
          };
        }),
      };
    });

    setSummaryTableData2(fattenData);
  }, [tableData]);

  useEffect(() => {
    const materialTotals = {};

    tableData.forEach((row) => {
      const key = row.material_type_name;
      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_sub_category: row.material_type_sub_category,
          material_type_name: key,
          total_quantity: 0,
          total_cost: 0,
          uom: row.material_wise_uom || "MT",
          sizeGroups: {},
        };
      }

      // Convert quantity to MT
      let qtyMT = 0;
      if ((row.material_wise_uom || row.uom) === "KG") {
        qtyMT = (row.quantity || 0) / 1000;
      } else {
        qtyMT = row.quantity || 0;
      }

      const size = row.diameter || 0;

      const pricePerMT =
        Number(row.revised_bid_price_unit_rate || 0) +
        Number(row.revised_bid_price_unit_rate_of_freight || 0);
      if (!materialTotals[key].sizeGroups[size]) {
        materialTotals[key].sizeGroups[size] = {
          total_quantity: 0,
          total_cost: 0,
        };
      }
      materialTotals[key].sizeGroups[size].total_quantity += qtyMT;
      materialTotals[key].sizeGroups[size].total_cost += pricePerMT * qtyMT;
    });
    const fattenData = Object.values(materialTotals).map((material) => {
      const sizeGroups = material.sizeGroups;
      let totalCost = 0;
      let totalQty = 0;
      Object.values(sizeGroups).forEach(({ total_quantity, total_cost }) => {
        totalQty += total_quantity;
        totalCost += total_cost;
      });

      const averagePriceKG = totalQty ? totalCost / (totalQty * 1000) : 0;
      const averagePriceMT = averagePriceKG * 1000;
      return {
        material_type_sub_category: material.material_type_sub_category,
        material_type_name: material.material_type_name,
        total_quantity: totalQty,
        total_cost: totalCost,
        averagePriceKG,
        averagePriceMT,
        sizes: Object.entries(sizeGroups).map(([size, data]) => {
          const avgPriceKG = data.total_quantity
            ? data.total_cost / (data.total_quantity * 1000)
            : 0;
          return {
            size,
            total_quantity: data.total_quantity,
            total_cost: data.total_cost,
            averagePriceKG: averagePriceKG,
            averagePriceMT: averagePriceMT,
          };
        }),
      };
    });

    setSummaryTableDataRevised(fattenData);
  }, [tableData]);

  useEffect(() => {
    const materialTotals = {};

    tableData.forEach((row) => {
      const key = row.material_type_name;
      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_sub_category: row.material_type_sub_category,
          material_type_name: key,
          total_quantity: 0,
          total_cost: 0,
          uom: row.material_wise_uom || "MT",
          sizeGroups: {},
        };
      }

      let qtyMT = 0;
      if ((row.material_wise_uom || row.uom) === "KG") {
        qtyMT = (row.quantity || 0) / 1000;
      } else {
        qtyMT = row.quantity || 0;
      }

      const size = row.diameter || 0;

      const pricePerMT =
        Number(row.final_bid_price_unit_rate || 0) +
        Number(row.final_bid_price_unit_rate_of_freight || 0);
      if (!materialTotals[key].sizeGroups[size]) {
        materialTotals[key].sizeGroups[size] = {
          total_quantity: 0,
          total_cost: 0,
        };
      }

      materialTotals[key].sizeGroups[size].total_quantity += qtyMT;
      materialTotals[key].sizeGroups[size].total_cost += pricePerMT * qtyMT;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const sizeGroups = material.sizeGroups;
      let totalCost = 0;
      let totalQty = 0;
      Object.values(sizeGroups).forEach(({ total_quantity, total_cost }) => {
        totalQty += total_quantity;
        totalCost += total_cost;
      });

      const averagePriceKG = totalQty ? totalCost / (totalQty * 1000) : 0;
      const averagePriceMT = averagePriceKG * 1000;


      return {
        material_type_sub_category: material.material_type_sub_category,
        material_type_name: material.material_type_name,
        total_quantity: totalQty,
        total_cost: totalCost,
        averagePriceKG,
        averagePriceMT,
        sizes: Object.entries(sizeGroups).map(([size, data]) => {
          const avgPriceKG = data.total_quantity
            ? data.total_cost / (data.total_quantity * 1000)
            : 0;
          return {
            size,
            total_quantity: data.total_quantity,
            total_cost: data.total_cost,
            averagePriceKG: averagePriceKG,
            averagePriceMT: averagePriceMT,
          };
        }),
      };
    });

    setSummaryTableDataFinal(fattenData);
  }, [tableData]);

  const columns4 = [
    {
      title: "R0 - Initial BID (without GST)",
      children: [
        {
          title: "Sub category",
          dataIndex: "material_type_sub_category",
          width: 140,
          render: (text) => {
            return text;
          },
        },
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
          render: (text, record) => {
            if (record.uom !== "Cubic Meter") {
              return <span>{text}</span>;
            }
          },
        },
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (initialBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
          title: "Average Price/KG",
          dataIndex: "averagePriceKG",
          key: "averagePriceKG",
          align: "right",
          render: (averagePriceKG) => {
            if (initialBidDates && isNaN(averagePriceKG)) {
              return "Not Quoted";
            } else {
              return averagePriceKG
                ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                : `₹ 0`;
            }
          },
        },
      ],
    },
  ];

  const columns4Revised = [
    {
      title: "R1 - Revised BID (without GST)",
      children: [
        {
          title: "Sub category",
          dataIndex: "material_type_sub_category",
          width: 140,
          render: (text) => {
            return text;
          },
        },
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
          render: (text, record) => {
            if (record.uom !== "Cubic Meter") {
              return <span>{text}</span>;
            }
          },
        },
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (initialBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
          title: "Average Price/KG",
          dataIndex: "averagePriceKG",
          key: "averagePriceKG",
          align: "right",
          render: (averagePriceKG) => {
            if (initialBidDates && isNaN(averagePriceKG)) {
              return "Not Quoted";
            } else {
              return averagePriceKG
                ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                : `₹ 0`;
            }
          },
        },
      ],
    },
  ];

  const columns4Final = [
    {
      title: "R - Final BID (without GST)",
      children: [
        {
          title: "Sub category",
          dataIndex: "material_type_sub_category",
          width: 140,
          render: (text) => {
            return text;
          },
        },
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
        },
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (finalBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
          title: "Average Price/KG",
          dataIndex: "averagePriceKG",
          key: "averagePriceKG",
          align: "right",
          render: (averagePriceKG) => {
            if (finalBidDates && isNaN(averagePriceKG)) {
              return "Not Quoted";
            } else {
              return averagePriceKG
                ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                : `₹ 0`;
            }
          },
        },
      ],
    },
  ];

  const handleCheckboxChange = (e) => {
    const value = e.target.checked;
    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: value,
    }));
  };

  const resetUnitRateWithGst = (item) => {
    item.bid_rfq_site_details.forEach((site) => {
      site.bid_rfq_material_details.forEach((material) => {
        material.unit_rate_with_gst = null;
      });
    });
    return item;
  };
  const handleBidSubmission = () => {
    if (state.is_final_bid_price) {
      handleSubmit();
    } else {
      handleSubmit();
      resetGSTValues();
      setCurrentStep(currentStep + 1);
    }
  };

  useEffect(() => {
    if (currentStep === 3) {
      //   navigate(`/rfq-vendor-request-for-quotation/history/1`);
    }
  }, [currentStep, CategoryId]);

  const handleSubmit = async () => {
    const currentDate = (() => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    })();

    const updatedTableData = tableData.map((item) => {
      if (!item.isSubtotal && item.material_type_name) {
        return {
          ...item,
          initial_bid_price_date: currentDate,
          revised_bid_price_date: currentDate,
          final_bid_price_date: currentDate,
        };
      }
      return item;
    });

    setTableData(updatedTableData);
    const uniqueEntries = new Map();
    const payload = {
      vendor: VendorId,
      bid_rfq_city_wise_detail: Array.from(
        tableData
          .reduce((cities, entry) => {
            if (!entry.siteId || entry.isSubtotal) return cities;

            const key = `${entry.siteId}_${entry.material_type}`;
            if (!uniqueEntries.has(key)) {
              uniqueEntries.set(key, true);
              if (!cities.has(entry.city_name)) {
                cities.set(entry.city_name, []);
              }
              cities.get(entry.city_name).push({
                site_id: entry.siteId,
                site_name: entry.site_name,
                site_wise_uom: entry.material_wise_uom,
                bid_rfq_material_details: [
                  {
                    material_type: entry.material_type,
                    initial_bid_price_unit_rate:
                      entry.initial_bid_price_unit_rate,
                    initial_bid_price_date: entry.initial_bid_price_date,
                    initial_bid_price_unit_rate_of_freight:
                      entry.initial_bid_price_unit_rate_of_freight,
                    revised_bid_price_unit_rate:
                      entry.revised_bid_price_unit_rate,
                    revised_bid_price_date: entry.revised_bid_price_date,
                    revised_bid_price_unit_rate_of_freight:
                      entry.initial_bid_price_unit_rate_of_freight,
                    final_bid_price_unit_rate:
                      entry.initial_bid_price_unit_rate,
                    final_bid_price_unit_rate_of_freight:
                      entry.initial_bid_price_unit_rate_of_freight,
                    final_bid_price_date: entry.final_bid_price_date,
                  },
                ],
              });
            }
            return cities;
          }, new Map())
          .values()
      ),
    };

    try {
      setLoading(true);
      let response;
      response = await patchRequest(
        `bid-rfq/${vendorBidId}/create-bid-rfq22/`,
        payload
      );

      if (response.data.success) {
        setLoading(false);

        let responseData = await getRequest(
          `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${VendorId}22`
        );

        if (currentStep === 0) {
          SuccessNotificationMsg(t("bidding_of_R0"));
        } else if (currentStep === 1) {
          SuccessNotificationMsg(t("bidding_of_R1"));
        } else {
          SuccessNotificationMsg(t("bidding_of_R"));
        }

        const newState2 = {
          vendor: VendorId,
          bid_rfq_vendor_detail:
            responseData.data.data[0].rfq_site_wise_vendor.map((site) => ({
              rfq_material_type_name: site.rfq_material_type_name,
              rfq_material_type: site.rfq_material_type_id,
              bid_rfq_detail: site.bid_rfq_detail.map((detail) => ({
                id: detail.bid_rfq_id,
                rfq_vendor_detail: detail.rfq_vendor_detail_id,
                purchase_requisition_site_id:
                  detail.purchase_requisition_site_id,
                purchase_requisition_site_name:
                  detail.purchase_requisition_site_name,
                site_wise_total_quantity: detail.site_wise_total_quantity,
                initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
                initial_bid_price_unit_rate_of_freight:
                  detail.initial_bid_price_unit_rate_of_freight,
                initial_bid_price_total_unit_rate:
                  detail.initial_bid_price_total_unit_rate,
                initial_bid_price_date: currentDate,
                revised_bid_price_unit_rate: detail.revised_bid_price_unit_rate,
                revised_bid_price_unit_rate_of_freight:
                  detail.revised_bid_price_unit_rate_of_freight,
                revised_bid_price_total_unit_rate:
                  detail.revised_bid_price_total_unit_rate,
                final_bid_price_unit_rate: detail.final_bid_price_unit_rate,
                final_bid_price_unit_rate_of_freight:
                  detail.final_bid_price_unit_rate_of_freight,
                final_bid_price_total_unit_rate:
                  detail.final_bid_price_total_unit_rate,
              })),
            })),
        };

        setNewState2(newState2);
        setTableData(newState2);
        SuccessNotificationMsg(t("bidding_of_R0"));
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const dataSource = {
    isFinalBidPrice: false,
    company: null,
    rfqNumber: null,
    currency: null,
    priceBasis: null,
    freight: null,
    unloading: null,
    transportInsurance: null,
    openOrder: false,
    amountCap: null,
    timelineCap: null,
    deliveryDate: null,
    deliveryStartDate: null,
    deliveryEndDate: null,
    rfqDueDate: null,
    bidRfqCityWiseDetail: [
      {
        cityName: null,
        cityId: null,
        bidRfqSiteDetails: [
          {
            siteId: null,
            siteName: null,
            siteWiseUom: null,
            totalUnitRateOfCement: "",
            rfqVendorDetail: "",
            bidRfqMaterialDetails: [
              {
                materialTypeName: null,
                rfqMaterialDetail: null,
                gstRate: null,
                materialType: null,
                materialTotalQuantity: null,
                materialWiseUom: null,
                initialBidPriceUnitRate: null,
                initialBidPriceUnitRateOfFreight: null,
                revisedBidPriceUnitRate: null,
                revisedBidPriceUnitRateOfFreight: null,
                finalBidPriceUnitRate: null,
                finalBidPriceUnitRateOfFreight: null,
                unitRateWithGst: null,
                amountWithoutGst: null,
                amountWithGst: null,
                lqpForThisClient: 5678,
                lqpForThisAnyClient: 2290,
              },
            ],
          },
        ],
      },
    ],
  };

  const transformedData = {
    companyName: rfqDetails.company,
    rfqnumber: rfqDetails.rfq_number,
    rfqcurrency: rfqDetails.currency_name,
    rfqpricebasis: rfqDetails.price_basis,
    rfqfreight: rfqDetails.freight,
    rfqunloading: rfqDetails.unloading,
    rfqtransportInsurance: rfqDetails.transport_insurance,
    rfqduedate: rfqDetails.rfq_due_date,
    rfqopendeliverydate: rfqDetails.delivery_date,
    rfqamountcap: rfqDetails.amount_cap || "N/A",
    rfqtimelinecap: rfqDetails.open_order ? "Timeline Cap Data" : "N/A",
    rfqdeliverystartdate: rfqDetails.delivery_start_date || "N/A",
    rfqdeliveryenddate: rfqDetails.delivery_end_date || "N/A",
    open_order: rfqDetails.open_order,
  };

  const columns1 = [
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "RFQ Number",
      dataIndex: "rfqnumber",
      key: "rfqnumber",
    },
    {
      title: "Currency",
      dataIndex: "rfqcurrency",
      key: "rfqcurrency",
    },
    {
      title: "Price Basis",
      dataIndex: "rfqpricebasis",
      key: "rfqpricebasis",
    },
    {
      title: "Freight",
      dataIndex: "rfqfreight",
      key: "rfqfreight",
    },
    {
      title: "Unloading",
      dataIndex: "rfqunloading",
      key: "rfqunloading",
    },
    {
      title: "Transport Insurance",
      dataIndex: "rfqtransportInsurance",
      key: "rfqtransportInsurance",
    },
    {
      title: "RFQ Due Date",
      dataIndex: "rfqduedate",
      key: "rfqduedate",
    },
    !rfqData.open_order && {
      title: "Delivery Date",
      dataIndex: "rfqopendeliverydate",
      key: "rfqopendeliverydate",
      render: (text, record) =>
        record.open_order ? "N/A" : record.rfqopendeliverydate,
    },
    rfqData.open_order && {
      title: "Amount Cap",
      dataIndex: "rfqamountcap",
      key: "rfqamountcap",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery Start Date",
      dataIndex: "rfqdeliverystartdate",
      key: "rfqdeliverystartdate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery End Date",
      dataIndex: "rfqdeliveryenddate",
      key: "rfqdeliveryenddate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
  ].filter(Boolean);


  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename" style={{ whiteSpace: "nowrap" }}>
            <h3>View - BID RFQ Vendor</h3>
          </div>
   
        </div>
      </div>
      <Content className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec ">
            <div className="PR-body" style={{ padding: "0px" }}>
              <div
                style={{
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#fff",
                  marginBottom: "16px",
                }}
              >
                <Collapse
                  defaultActiveKey={[0]}
                  key={0}
                  className="custom-collapse-table"
                >
                  <Panel header={"RFQ Details"} key={0}>
                    <div style={{ marginTop: "10px" }}>
                      <Table
                        className="custom-head"
                        columns={columns1}
                        dataSource={[transformedData]}
                        pagination={false}
                      />
                    </div>
                  </Panel>
                </Collapse>
              </div>

              <div>
                <Form autoComplete="off" ref={formRef} onFinish={handleSubmit}>
                  <Spin spinning={apiLoading}>
                    <Table
                      columns={groupedColumns}
                      dataSource={tableData}
                      pagination={false}
                      bordered
                      scroll={{
                        x: 1000,
                      }}
                      sticky
                    />
                  </Spin>
                  <Row gutter={16} className="footerTablesContainer">
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable3"
                      style={{ paddingTop: "16px" }}
                    >
                      {finalBidDates && (
                        <Table
                          columns={columns4Final}
                          dataSource={summaryTableDataFinal}
                          pagination={false}
                          bordered
                          scroll={{
                            x: 500,
                          }}
                        />
                      )}
                      {!hideR1 && revisedBidDates && (
                        <Table
                          columns={columns4Revised}
                          dataSource={summaryTableDataRevised}
                          pagination={false}
                          bordered
                          scroll={{
                            x: 500,
                          }}
                        />
                      )}
                      {!hideR0 && (
                        <Table
                          columns={columns4}
                          dataSource={summaryTableData2}
                          pagination={false}
                          bordered
                          scroll={{
                            x: 400,
                          }}
                        />
                      )}
                    </Col>
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable4"
                      style={{ paddingTop: "16px" }}
                    >
                      <Table
                        columns={columns3}
                        dataSource={summaryTableData}
                        pagination={false}
                        bordered
                        scroll={{
                          // x: 1500,
                          x: 600,
                        }}
                      />
                    </Col>
                  </Row>

                  {revisedBidDates && (
                    <>
                      <div className="FormFooter">
                        <Checkbox
                          checked={hideR0}
                          onChange={handleHideR0Change}
                        >
                          Hide Initial BID Price - R0
                        </Checkbox>
                      </div>
                    </>
                  )}
                  {finalBidDates && !AsFinalBidPrice && (
                    <>
                      <div className="FormFooter">
                        <Checkbox
                          checked={hideR1}
                          onChange={handleHideR1Change}
                        >
                          Hide Revised BID Price - R1
                        </Checkbox>
                      </div>
                    </>
                  )}
                </Form>
              </div>
            </div>
          </section>
        </div>
      </Content>
    </>
  );
};

export default DiameterWiseViewVendorBidRFQ;
